import React from "react";
import "../styles/DressCode.css";
import { FaFilePdf } from "react-icons/fa";

// PDF viewer imports
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// Import PDF correctly
import Dress_Code from "../Assets/Pdfs/Dress_Code.pdf";

export default function DressCode() {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <div className="dress-code-page">
      <section className="dress-code-section pdf-section">
        <h2>
          <FaFilePdf className="pdf-icon" /> Dress Code
        </h2>

        {/* PDF Viewer */}
        <div className="pdf-viewer">
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer
              fileUrl={Dress_Code}
              plugins={[defaultLayoutPluginInstance]}
            />
          </Worker>
        </div>

        {/* Download link */}
        <p className="pdf-download">
          <a href={Dress_Code} target="_blank" rel="noopener noreferrer">
            Download Dress Code Policy
          </a>
        </p>
      </section>

      <footer className="dress-code-footer">
        <p>Thank you for maintaining professionalism and respect on campus.</p>
      </footer>
    </div>
  );
}
